
import { Component, Vue } from 'vue-property-decorator'
import { WinpressService } from '@/services'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import Skeleton from '@/components/skeleton/index.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'

@Component({
    name: 'winpress-demand-detail',
    components: {
        CreateDetailLayout,
        Skeleton,
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private isLoading = true
    private detailId = ''
    private changeLoading = false
    private mediaMap = {}
    private detail: any = {
        mobile: '',
        company: '',
        name: '',
        title: '',
        content: '',
        guests: [],
        bulletin_title: '',
        bulletin_content: '',
        guest_speech_title: '',
        guest_speech_content: '',
        news_brochure_title: '',
        news_brochure_content: '',
        bill_of_materials: [],
        created_at: '',
        updated_at: '',
        user: { id: '', name: '' },
        status: { id: 1 }
    }

    get matchGuests() {
        return this.detail.guests.map((n: any) => `${n.name} - ${n.company}`).join('、')
    }

    private created() {
        this.$title('Loading | 详情页 - 庖丁')
        this.detailId = this.$route.params.id
    }

    private async mounted() {
        this.isLoading = true
        await this.getDetail()
    }

    get matchStatus() {
        const status = {
            1: '未处理',
            2: '已处理'
        }
        return Reflect.get(status, this.detail.status.id)
    }

    private matchButtonType(status: number) {
        return this.detail.status.id === status ? 'primary' : 'default'
    }

    /** 解析后端返回的字符串数组字段 */
    private parseArrayField(value: any): any[] {
        if (Array.isArray(value)) return value
        if (typeof value === 'string' && value) {
            try {
                const parsed = JSON.parse(value)
                return Array.isArray(parsed) ? parsed : []
            } catch (e) {
                return []
            }
        }
        return []
    }

    /** 把后端 camelCase 数据转换为前端需要的 snake_case 格式 */
    private normalizeDetail(data: any) {
        return {
            ...data,
            bulletin_title: data.bulletinTitle,
            bulletin_content: data.bulletinContent,
            guest_speech_title: data.guestSpeechTitle,
            guest_speech_content: data.guestSpeechContent,
            news_brochure_title: data.newsBrochureTitle,
            news_brochure_content: data.newsBrochureContent,
            bill_of_materials: this.parseArrayField(data.billOfMaterials),
            created_at: data.createdAt,
            updated_at: data.updatedAt,
            medium_list: this.parseArrayField(data.mediumList),
            guests: this.parseArrayField(data.guests),
            user: data.user || (data.userId ? { id: data.userId, name: '' } : { id: '', name: '' }),
            status: typeof data.status === 'number' ? { id: data.status } : data.status
        }
    }
    /** 修改申请的信息 */
    private async getDetail() {
        const params = {
            id: +this.detailId
        }
        const result = await WinpressService.getWpDemandDetail(params)
        if (result.status === 200) {
            this.detail = this.normalizeDetail(result.data)
            this.mediaMap = {}
            this.formatMedia(this.detail.medium_list || [])
            this.$title(`${this.detail.title} | 需求详情 - 庖丁`)
            this.isLoading = false
        }
    }

    private formatMedia(medias: any[]) {
        medias.forEach(({ name, type }: any) => {
            const target = Reflect.get(this.mediaMap, type.id)
            if (target) {
                target.list.push(name)
            } else {
                Reflect.set(this.mediaMap, type.id, { type, list: [name] })
            }
        })
    }

    // 改变状态
    private async changeStatus(status: number) {
        this.changeLoading = true
        const params = {
            id: +this.detailId,
            status
        }
        const result = await WinpressService.updateWpDemandStatus(params)
        this.changeLoading = false
        if (result.status === 200) {
            this.detail.status.id = status
            return this.$msuccess('修改状态成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
}
